import {
  IsEmail,
  MaxLength,
  IsNotEmpty,
  IsBoolean,
  IsOptional,
} from 'class-validator';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Type } from 'class-transformer';

export class AuthResetPasswordDto {
  @ApiProperty({
    type: 'string',
    title: 'Email address',
    format: 'email',
  })
  @IsEmail()
  @IsNotEmpty()
  @MaxLength(50)
  email!: string;

  @ApiPropertyOptional({
    type: 'boolean',
    title: 'Set to true to send the admin token url and template.',
    default: false,
  })
  @Type(() => Boolean)
  @IsBoolean()
  @IsOptional()
  isAdmin?: boolean;
}
